/**
 * en-GB messages added by Phase 1 task S5 (docs/PHASE-1-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s5EnGB = {
    'nav.badges': 'Badges',
    'nav.badges.desc': 'Badge designs and printing',
    'error.template_in_use': 'Badges have been printed with this design, so it cannot be deleted. Archive it instead.',
    'error.no_badge_template': 'No badge design is set for the group or site of this visit.',
    'settings.badges': 'Badges',
    'settings.badges.defaultTemplateId': 'Default badge design',
    'settings.badges.mediaWarning': 'Warn when the loaded labels do not match the design',
    'settings.badges.print': 'Print badges',
    'settings.badges.print.never': 'Never',
    'settings.badges.print.auto': 'Automatically at sign-in',
    'settings.badges.print.ask': 'Ask the visitor',
    'settings.badges.templateId': 'Badge design (blank = the default for the site)',
    'badge.warning.unknown_version': 'The kiosk printed a badge design this server does not know about.',
};
//# sourceMappingURL=s5.js.map